/**
 * A class defines a limit of hours an employee can work in one week.
 */
export class MaximumWorkingHours {
  hours: number;
  startDate: string;

  /**
   * @param hours the maximum number of hours the employee can work in one week.
   * @param startDate the Monday from which this setting takes effect.
   */
  constructor(hours: number, startDate: string) {
    this.hours = hours;
    this.startDate = startDate;
  }
}
